import Tab from "components/DesignSystem/Tab/Tab";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import { ArchivedCrm } from "./ArchivedCrm";
import SalesCrm from "./salesCrm";
import SalesCrmProfiles from "./SalesCrmProfiles";
import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { useSecondaryNav } from "components/AppLayout/SecondaryNavContext";
import { usePageTitleSetter } from "hooks/usePageTitleSetter";
import { useEffect } from "react";

const SALES_CRM_TAB_TITLES = {
  GROUPS: "Groups",
  PROFILES: "Profiles",
  ARCHIVED: "Archived",
} as const;

export const SalesCrmRoute = ({ selectedTabIs }: { selectedTabIs: string }) => {
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();
  const { active: secondaryNavActive } = useSecondaryNav();
  const setPageTitle = usePageTitleSetter();

  let activeTabTitle: string = SALES_CRM_TAB_TITLES.GROUPS;
  if (pathname.startsWith(`${url}/profiles`))
    activeTabTitle = SALES_CRM_TAB_TITLES.PROFILES;
  if (pathname.startsWith(`${url}/archived`))
    activeTabTitle = SALES_CRM_TAB_TITLES.ARCHIVED;

  useEffect(() => {
    if (!secondaryNavActive) {
      return;
    }

    setPageTitle(activeTabTitle);
  }, [secondaryNavActive, activeTabTitle, setPageTitle]);

  const header = secondaryNavActive ? undefined : (
    <Header
      v2
      title={<div className="t-flex t-gap-2 t-items-center">Sales CRM</div>}
      bottom={
        <Tab.Root defaultValue={pathname} value={pathname}>
          <Tab.List>
            <Tab.NavTrigger exact value={url}>
              Groups
            </Tab.NavTrigger>
            <Tab.NavTrigger exact value={`${url}/profiles`}>
              Profiles
            </Tab.NavTrigger>
            <Tab.NavTrigger exact value={`${url}/archived`}>
              Archived
            </Tab.NavTrigger>
          </Tab.List>
        </Tab.Root>
      }
    />
  );

  return (
    <DashboardLayout header={header}>
      <Switch>
        <Route exact path={path}>
          <SalesCrm />
        </Route>
        <Route exact path={`${path}/profiles`}>
          <SalesCrmProfiles />
        </Route>
        <Route exact path={`${path}/archived`}>
          <ArchivedCrm />
        </Route>
      </Switch>
    </DashboardLayout>
  );
};
